import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardHeader, CardTitle, CardDescription, CardFooter } from "@/components/ui/card";
const portals = [{
  id: "nepean-north",
  label: "NEPEAN NORD",
  title: "Bayshore & Westboro",
  description: "Services de photographie locale pour les quartiers du nord de Nepean.",
  link: "/PricingPage"
}, {
  id: "nepean-south",
  label: "NEPEAN SUD",
  title: "Barrhaven & Greenboro",
  description: "Séances professionnelles pour les familles et entreprises du sud d'Ottawa.",
  link: "/PricingPage"
}];
export default function IntroductionNepeanLocal() {
  return <section data-section-id="223338" id="introduction-nepean-local" className="bg-background text-foreground px-4 py-24 md:px-8 lg:px-16">
      <div className="mx-auto flex max-w-7xl flex-col gap-16">
        {/* Header Section */}
        <div className="mx-auto flex max-w-3xl flex-col items-center gap-6 text-center">
          <div className="bg-secondary/20 border-secondary/30 text-primary inline-flex items-center rounded-md border px-4 py-1.5 text-xs font-semibold tracking-wider uppercase">
            Photographie Locale
          </div>
          <h2 className="font-default text-foreground text-4xl font-bold tracking-tight md:text-5xl">
            Votre Studio à Nepean
          </h2>
          <p className="text-muted-foreground text-lg font-default">
            Que vous soyez à Bells Corners, Kanata ou Westboro, nous capturons vos moments précieux avec une expertise locale inégalée.
          </p>
        </div>

        {/* Portals Grid */}
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2">
          {portals.map((portal, index) => <Card key={portal.id} data-index={index} className="border-border bg-card hover:border-secondary/50 hover:shadow-xl flex h-full flex-col justify-between transition-all duration-300 rounded-lg">
              <CardHeader className="p-8 pb-0 md:p-12">
                <span className="text-primary mb-4 block text-xs font-bold tracking-widest uppercase">
                  {portal.label}
                </span>
                <CardTitle className="font-default text-foreground mb-4 text-3xl md:text-4xl">
                  {portal.title}
                </CardTitle>
                <CardDescription className="text-muted-foreground text-base font-default">
                  {portal.description}
                </CardDescription>
              </CardHeader>
              <CardFooter className="p-8 pt-8 md:p-12">
                <Button asChild variant="outline" className="hover:border-primary hover:bg-primary hover:text-primary-foreground border-primary text-primary w-fit rounded-md transition-all duration-300 font-semibold">
                  <Link to={portal.link}>
                    Réserver à Nepean
                    <ArrowRight className="ml-2 size-4" />
                  </Link>
                </Button>
              </CardFooter>
            </Card>)}
        </div>
      </div>
    </section>;
}